export enum EnvironmentType {
  LOCAL = 'local',
  DEV = 'dev',
  STG = 'stg',
  PROD = 'prod'
}
